import { getAuth } from 'firebase/auth';

import { handlePermissionError } from '../utils/error_handling';

const hasUserClaim = async role => {
	let auth;
	try {
		auth = getAuth();
		const user = auth.currentUser;

		if (!user) return false;

		const tokenResult = await user.getIdTokenResult(true);

		return tokenResult.claims.role === role;
	} catch (error) {
		handlePermissionError(error, { role, userId: auth?.currentUser?.uid });
		return false;
	}
};

export const isAdminUser = () => hasUserClaim('admin');
export const isSuperUser = () => hasUserClaim('superuser');
export const isClientUser = () => hasUserClaim('client');
export const isConsultantUser = () => hasUserClaim('consultant');
